const FormDatafy = (json) => {
    const returnValue = new FormData();
    Object.keys(json).forEach((key) => {
        returnValue.append(key, json[key]);
    });

    return returnValue;
};

export default FormDatafy;
